enum Event
{
    SessionExpired = 'SessionExpired'
}

export default Event;